// extracted by mini-css-extract-plugin
export default {"container":"lhKfy","icon":"qEPWN","onlyIcon":"RCeUm","title":"kXs7l"};